import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { TeamGroupsTable } from "features/teamGroup/TeamGroupsTable";
import { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import "style/discoverPage.css";

interface TeamGroupListLocationState {
	showGameCountPendingNotice?: boolean;
}

export function TeamGroupListPage() {
	const location = useLocation();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const [showGameCountPendingNotice, setShowGameCountPendingNotice] = useState(false);

	useEffect(() => {
		setScrollBehavior();
	}, []);

	useEffect(() => {
		const locationState = location.state as TeamGroupListLocationState | null;
		if (locationState?.showGameCountPendingNotice !== true) {
			return;
		}

		setShowGameCountPendingNotice(true);
		navigate(`${location.pathname}${location.search}`, { replace: true, state: {} });
	}, [location.pathname, location.search, location.state, navigate]);

	const handleRefreshGameCounts = useCallback(() => {
		void queryClient.resetQueries({ queryKey: ["getTeamGroups"] });
	}, [queryClient]);

	return (
		<div className="discover-container discover-container--wide">
			<div className="pageHeading" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<h1>Team Groups Management</h1>
				<Link to="/team-group/new" className="btn btn-light-blue">
					+ Add Team Group
				</Link>
			</div>
			{showGameCountPendingNotice ? (
				<div className="teamGroupsListPage-notice" role="status">
					<span>
						Number of Games may take a moment to update after saving. Use Refresh list if the value still
						looks outdated.
					</span>
					<button type="button" className="teamGroupsListPage-noticeAction" onClick={handleRefreshGameCounts}>
						Refresh list
					</button>
				</div>
			) : null}
			<TeamGroupsTable />
		</div>
	);
}

export default TeamGroupListPage;
